module.exports = __webpack_public_path__ + "mastercard.c0ff6f.svg";